'use client'

import React from 'react'

import HashGeneratorLayout from '../HashGeneratorLayout'
import generateSHA256Hash from './generateSHA256Hash'


export default function SHA256Generator() {
  return (
    <HashGeneratorLayout
      generateHash={generateSHA256Hash}
    />
  )
}
